import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import ReduxPromise from 'redux-promise';
import { BrowserRouter, HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import { IntlProvider } from "react-intl";
import {config} from './constants/domainConfig';

// Styles
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss';
// Import Swiper css
import 'react-id-swiper/src/styles/scss/swiper.scss';

import 'swiper/dist/css/swiper.min.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
// Import Main styles for this application

import '../scss/style.scss';

// Views
import App from './containers/App';
import RootReducer from './reducers/';
import {console_log, getParameters} from './utils/helper';

//localisation
import { addLocaleData } from "react-intl";
import locale_en from 'react-intl/locale-data/en';
import locale_ar from 'react-intl/locale-data/ar';
import locale_kk from 'react-intl/locale-data/kk';
import locale_fr from 'react-intl/locale-data/fr';
import locale_sv from "react-intl/locale-data/sv";
import locale_be from "react-intl/locale-data/be";
import locale_no from "react-intl/locale-data/no";
import locale_vi from "react-intl/locale-data/vi";
import locale_tr from "react-intl/locale-data/tr";
import locale_es from "react-intl/locale-data/es";
import locale_it from "react-intl/locale-data/it";
import locale_cy from "react-intl/locale-data/cy";
import locale_de from "react-intl/locale-data/de";
import locale_el from "react-intl/locale-data/el";
import locale_ro from "react-intl/locale-data/ro";
import locale_cz from "react-intl/locale-data/cs";
import locale_pt from "react-intl/locale-data/pt";
import locale_lt from "react-intl/locale-data/lt";
import locale_si from "react-intl/locale-data/si";
import locale_pl from "react-intl/locale-data/pl";
import locale_bg from "react-intl/locale-data/bg";
import locale_th from "react-intl/locale-data/th";

addLocaleData([
    ...locale_en, 
    ...locale_ar, 
    ...locale_kk, 
    ...locale_fr, 
    ...locale_sv,
    ...locale_be, 
    ...locale_no,
    ...locale_vi,
    ...locale_tr,
    ...locale_es,
    ...locale_it,
    ...locale_cy, 
    ...locale_de, 
    ...locale_el, 
    ...locale_ro, 
    ...locale_cz,
    ...locale_pt,
    ...locale_lt,
    ...locale_si,
    ...locale_pl,
    ...locale_bg,
    ...locale_th
]);

import messages_ar from "./translations/ar.json";
import messages_en from "./translations/en.json";
import messages_kk from "./translations/kk.json";
import messages_fr from "./translations/fr.json";
import messages_sv from "./translations/sv.json";
import messages_be from "./translations/be.json";
import messages_no from "./translations/no.json";
import messages_vi from "./translations/vi.json";
import messages_tr from "./translations/tr.json";
import messages_es from "./translations/es.json";
import messages_it from "./translations/it.json";
import messages_cy from "./translations/cy.json";
import messages_de from "./translations/de.json";
import messages_el from "./translations/el.json";
import messages_ro from "./translations/ro.json";
import messages_cz from "./translations/cz.json";
import messages_pt from "./translations/pt.json";
import messages_lt from "./translations/lt.json";
import messages_si from "./translations/si.json";
import messages_pl from "./translations/pl.json";
import messages_bg from "./translations/bg.json";
import messages_th from "./translations/th.json";

const messages = {
    'ar': messages_ar,
    'en': messages_en,
    'kk': messages_kk,
    'fr': messages_fr,
    'sv': messages_sv,
    'be': messages_be,
    'no': messages_no,
    'vi': messages_vi,
    'tr': messages_tr,
    'es': messages_es,
    'it': messages_it,
    'cy': messages_cy,
    'de': messages_de,
    'el': messages_el,
    'ro': messages_ro,
    'cs': messages_cz,
    'pt': messages_pt,
    'lt': messages_lt,
    'si': messages_si,
    'pl': messages_pl,
    'bg': messages_bg,
    'th': messages_th
};


let language=config.lang;
const persistedState = (typeof sessionStorage.getItem('reduxStore') != "undefined") ? JSON.parse(sessionStorage.getItem('reduxStore')) : null;
const connectWithReduxMiddleWare = applyMiddleware(ReduxPromise)(createStore);
const store = (persistedState != null)? connectWithReduxMiddleWare(RootReducer, persistedState): connectWithReduxMiddleWare(RootReducer);
// const store = connectWithReduxMiddleWare(RootReducer);
store.subscribe(() => {
    sessionStorage.setItem('reduxStore', JSON.stringify(store.getState()));
});


class LangWrapper extends Component {

    componentWillMount(){
        const h  = document.querySelector("html");
        if(config.lang === 'be') h.setAttribute("lang", "nl")
        else h.setAttribute("lang", config.lang);
        if(config.subDomain === 'eg'){
            const lang = getParameters("lang");
            if(lang.exist && lang.value === "en") config.lang = "en";
            h.setAttribute("lang", "en");
        }
    }

     changeLang(event){
        const h  = document.querySelector("html");
         if(config.subDomain === 'dz'){
             if(event === 'fr'){
                 config.lang = 'fr'
                 h.setAttribute("lang", "fr")
             }
             if(event === 'ar'){
                 config.lang = 'ar'
                 h.setAttribute("lang", "ar")
             }
         }
         if(config.subDomain === 'eg'){
             if(event === 'en'){
                 config.lang = 'en'
                 h.setAttribute("lang", "en")
             }
             if(event === 'ar'){
                 config.lang = 'ar'
                 h.setAttribute("lang", "ar")
             }
         }
         if(config.subDomain === 'ch'){
             if(event === 'de'){
                 config.lang = 'de'
                 h.setAttribute("lang", "de")
             }
             if(event === 'fr'){
                 config.lang = 'fr'
                 h.setAttribute("lang", "fr")
             }
             if(event === 'it'){
                config.lang = 'it'
                h.setAttribute("lang", "it")
            }
             if(event === 'en'){
                config.lang = 'en'
                h.setAttribute("lang", "en")
            }
         }
         if(config.subDomain === 'pl'){
             if(event === 'pl'){
                 config.lang = 'pl'
                 h.setAttribute("lang", "pl")
             }
             if(event === 'en'){
                config.lang = 'en'
                h.setAttribute("lang", "en")
            }
         }
         if(config.subDomain === 'be'){
            if(event === 'de'){
                config.lang = 'de'
                h.setAttribute("lang", "de")
            }
            if(event === 'fr'){
                config.lang = 'fr'
                h.setAttribute("lang", "fr")
            }
            if(event === 'be'){
                config.lang = 'be'
                h.setAttribute("lang", "nl")
            }
        }
         this.setState({})
     }

   
    render() {
        return (
        <IntlProvider locale={config.lang} messages={messages[config.lang]}>
                <HashRouter>
                <Switch>
                    <App changeLang={this.changeLang.bind(this)} currentLang={config.lang} />
                    </Switch>    
        </HashRouter>
        </IntlProvider> )
    }

}

ReactDOM.render(
<Provider store={store}>
    <LangWrapper/>
</Provider>,
document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js